export default __webpack_public_path__ + "static/media/visiot-logo-sivi.ccf032cd.svg";